import { UserAttributesClient } from 'frontend-preferences-client';
const userAttributesClient = UserAttributesClient.forCaller('calling-lifecycle-internal');

/**
 * The backend enforces a character limit each value.
 */
const MAX_DATA_LENGTH = 1000;
export function encodeSettingsValue(value) {
  const length = typeof value === 'string' ? value.length : 0;
  if (length > MAX_DATA_LENGTH) {
    const error = new Error(`Expected encodedValue.length to be less than ${MAX_DATA_LENGTH}`);
    throw error;
  }
  return JSON.stringify(value);
}
export function fetchUserSettingsAPI(keyValueDefaults) {
  return userAttributesClient.batchFetch(keyValueDefaults).then(response => {
    return response;
  });
}
export function saveUserSettingAPI({
  key,
  value
}) {
  try {
    const encodedValue = encodeSettingsValue(value);
    return userAttributesClient.write(key, encodedValue);
  } catch (error) {
    return Promise.reject(error);
  }
}